import { Link } from 'react-router-dom';
import { CONTACT_EMAIL, BRAND } from '../../config/site';

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/5 bg-[#040404]">
    <div className="mx-auto max-w-6xl px-6 py-16 sm:px-10">
      <div className="flex flex-col gap-10 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <div className="flex items-center gap-3">
            <img src="/assets/app-icon.webp" alt="Logo Despertar da Águia" loading="lazy" className="h-9 w-9 rounded-xl border border-white/10" />
            <span className="font-display text-sm font-bold uppercase tracking-[0.25em] text-white">{BRAND}</span>
          </div>
          <p className="mt-4 max-w-sm text-xs leading-relaxed text-neutral-500">
            Disciplina, foco e hábitos — uma jornada de 28 dias para reconstruir sua mentalidade.
          </p>
        </div>

        <nav className="flex flex-col gap-3 text-sm text-neutral-400">
          <Link data-testid="footer-link-termos" to="/termos" className="transition-colors duration-300 hover:text-gold-light">
            Termos de Uso
          </Link>
          <Link data-testid="footer-link-privacidade" to="/privacidade" className="transition-colors duration-300 hover:text-gold-light">
            Política de Privacidade
          </Link>
          <a data-testid="footer-link-contato" href={`mailto:${CONTACT_EMAIL}`} className="transition-colors duration-300 hover:text-gold-light">
            Contato
          </a>
        </nav>
      </div>

      <div className="mt-12 border-t border-white/5 pt-8">
        <p data-testid="footer-disclaimer" className="max-w-3xl text-[11px] leading-relaxed text-neutral-600">
          Os resultados descritos nesta página podem variar de pessoa para pessoa e dependem da dedicação
          individual ao método. Este produto não substitui acompanhamento profissional.
        </p>
        <p className="mt-4 text-[11px] text-neutral-600">
          © {new Date().getFullYear()} {BRAND}. Todos os direitos reservados.
        </p>
      </div>
    </div>
  </footer>
);
